import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../utils/cn';

const textareaVariants = cva(
  'flex [field-sizing:content] w-full resize-none rounded-lg border border-input bg-transparent px-3 py-2 text-base ring-offset-background transition-colors placeholder:text-muted-foreground focus-visible:ring-1 focus-visible:ring-ring focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      size: {
        default: 'min-h-28',
        sm: 'min-h-8 px-4 py-0.5 text-sm',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);

export interface TextareaProps
  extends React.ComponentProps<'textarea'>, VariantProps<typeof textareaVariants> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, size, ...props }, ref) => {
    return <textarea className={cn(textareaVariants({ size }), className)} ref={ref} {...props} />;
  },
);
Textarea.displayName = 'Textarea';

export { Textarea, textareaVariants };
